import React, { Component } from 'react';
import PropTypes from "prop-types";
import moment from "moment";



class TimeCellRender extends Component {

  render() {
    return moment(this.props.value).format('HH:mm:ss');
  }
}

TimeCellRender.propTypes = {
  value: PropTypes.any,
};

export default TimeCellRender;